import React from 'react'
import { useTranslate } from 'react-admin'
import ReactQuill from 'react-quill'
import { useLangContext } from 'services/contexts/LangContext'
import { RAInputProps } from 'types/common'

type Props = Partial<RAInputProps> & {
  onChange?: (content: string) => void
  defaultValue?: string
  label?: string
}

const KRichTextInputMultilanguage: React.FC<Props> = ({
  defaultValue,
  onChange,
  label,
  disabled,
}) => {
  const translate = useTranslate()
  const { currentLang } = useLangContext()

  return (
    <>
      {label && <p>{translate(label)}</p>}

      <ReactQuill
        readOnly={disabled}
        key={currentLang}
        modules={{
          clipboard: {
            matchVisual: false,
          },
        }}
        style={{
          height: '100px',
          marginBottom: '50px',
          marginTop: '10px',
        }}
        defaultValue={defaultValue}
        onChange={onChange}
      />
    </>
  )
}

export default KRichTextInputMultilanguage
